import { render, staticRenderFns } from "./Twice.vue?vue&type=template&id=1ca03061&"
import script from "./Twice.vue?vue&type=script&lang=js&"
export * from "./Twice.vue?vue&type=script&lang=js&"
import style0 from "./Twice.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports